import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Send, Check } from "lucide-react";
import { T } from "../theme";


const inputStyle = {
  width: "100%", padding: "13px 16px",
  background: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.12)",
  borderRadius: 12, color: T.text,
  fontSize: "0.95rem", outline: "none",
  boxSizing: "border-box", fontFamily: "inherit",
  transition: "border-color 0.2s",
};

export default function ContactPage() {
  const navigate = useNavigate();
  const [form, setForm]     = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent]     = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = form;
    const body = `Name: ${name}\nEmail: ${email}\n\n${message}`;
    const mailtoUrl = `mailto:kandikonnect.app@gmail.com?subject=${encodeURIComponent(subject || "KandiKonnect Contact")}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoUrl;
    setSent(true);
  };

  const set = (field) => (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));

  return (
    <div style={{
      minHeight: "100vh", background: T.bg, color: T.text,
      fontFamily: "'Inter', system-ui, sans-serif",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "flex-start",
      padding: "48px 16px 80px",
    }}>
      <div style={{ width: "100%", maxWidth: 500 }}>

        {/* Back */}
        <button
          onClick={() => navigate(-1)}
          style={{
            display: "flex", alignItems: "center", gap: 8,
            background: "none", border: "none", cursor: "pointer",
            color: T.muted, fontSize: "0.88rem", fontWeight: 600,
            padding: "0 0 28px", marginLeft: -4,
          }}
        >
          <ArrowLeft size={16} /> Back
        </button>

        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <h1 style={{
            margin: "0 0 8px",
            fontFamily: "var(--font-display)",
            fontSize: "2rem", fontWeight: 700,
            color: T.purple,
            textShadow: `0 0 26px ${T.pink}60`,
          }}>
            Contact Us
          </h1>
          <p style={{ margin: 0, color: T.muted, fontSize: "0.9rem" }}>
            Got a question, idea, or just want to say PLUR? We'd love to hear from you.
          </p>
        </div>

        {sent ? (
          <div style={{
            textAlign: "center", padding: "48px 24px",
            background: T.card, border: T.border, borderRadius: 24,
          }}>
            <div style={{
              width: 64, height: 64, borderRadius: "50%", margin: "0 auto 20px",
              background: "linear-gradient(135deg, #b44fff, #ff3cac)",
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: "0 0 32px rgba(180,79,255,0.4)",
            }}>
              <Check size={28} color="#fff" />
            </div>
            <h2 style={{ margin: "0 0 10px", fontWeight: 800, color: T.text }}>
              Email client opened!
            </h2>
            <p style={{ margin: "0 0 24px", color: T.muted, fontSize: "0.9rem" }}>
              Your message is ready to send. Just hit send in your email app.
            </p>
            <button
              onClick={() => navigate("/")}
              style={{
                padding: "11px 28px", borderRadius: 50,
                background: "linear-gradient(135deg, #b44fff, #ff3cac)",
                border: "none", color: "#fff", fontWeight: 700,
                fontSize: "0.9rem", cursor: "pointer",
              }}
            >
              Back to KandiKonnect
            </button>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            style={{
              background: T.card, border: T.border, borderRadius: 24,
              padding: "28px 24px", display: "flex", flexDirection: "column", gap: 18,
            }}
          >
            <div>
              <label style={{ display: "block", fontSize: "0.72rem", fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>
                Your Name
              </label>
              <input
                type="text"
                required
                placeholder="Rave name or real name"
                value={form.name}
                onChange={set("name")}
                style={inputStyle}
                onFocus={e => e.target.style.borderColor = "rgba(180,79,255,0.5)"}
                onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
              />
            </div>

            <div>
              <label style={{ display: "block", fontSize: "0.72rem", fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>
                Your Email
              </label>
              <input
                type="email"
                required
                placeholder="you@example.com"
                value={form.email}
                onChange={set("email")}
                style={inputStyle}
                onFocus={e => e.target.style.borderColor = "rgba(180,79,255,0.5)"}
                onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
              />
            </div>

            <div>
              <label style={{ display: "block", fontSize: "0.72rem", fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>
                Subject
              </label>
              <input
                type="text"
                required
                placeholder="What's on your mind?"
                value={form.subject}
                onChange={set("subject")}
                style={inputStyle}
                onFocus={e => e.target.style.borderColor = "rgba(180,79,255,0.5)"}
                onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
              />
            </div>

            <div>
              <label style={{ display: "block", fontSize: "0.72rem", fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>
                Message
              </label>
              <textarea
                required
                rows={5}
                placeholder="Tell us everything..."
                value={form.message}
                onChange={set("message")}
                style={{ ...inputStyle, resize: "vertical", minHeight: 120 }}
                onFocus={e => e.target.style.borderColor = "rgba(180,79,255,0.5)"}
                onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
              />
            </div>

            <button
              type="submit"
              style={{
                display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                padding: "14px 0", borderRadius: 14,
                background: "linear-gradient(135deg, #ff3cac, #b44fff)",
                border: "none", color: "#fff", fontWeight: 800,
                fontSize: "1rem", cursor: "pointer",
                boxShadow: "0 0 28px rgba(180,79,255,0.4)",
                transition: "transform 0.15s",
              }}
              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
            >
              <Send size={17} /> Send Message
            </button>

            <p style={{ margin: 0, color: T.muted, fontSize: "0.75rem", textAlign: "center" }}>
              This will open your email app with the message pre-filled.
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
